import { FormControl, MenuItem, Select, TextField } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styles from './ProjectSelector.module.scss';
import { getClickedUser } from '../../../../redux/userManagement/actions';

const ProjectSelector = ({
	projects,
	projectSelected,
	setProjectSelected,
	getClickedUser,
	setFilterByRole,
}) => {
	useEffect(() => {
		console.log('projects[0]?.companyName', projects[0]?.id);
		setProjectSelected(projects[0]?.id);
	}, [projects]);

	const handleChange = (e) => {
		console.log('e.target.value', e.target.value);
		setProjectSelected(e.target.value);
		getClickedUser('');
		setFilterByRole('');
	};
	return (
		<div>
			<FormControl>
				<TextField
					style={{
						borderRadius: '4px',
						minWidth: '269px',
						width: '269px',
						boxSizing: 'border-box',
						border: '0.1px solid #e0e0e0',
					}}
					variant='outlined'
					value={projectSelected}
					onChange={handleChange}
					select
					SelectProps={{
						style: {
							backgroundColor: 'none',
							color: 'var(--text-mid-emphasis)',
							fontWeight: 'bold',
							height: '42px',

							'& .MuiSelect-select:focus': {
								backgroundColor: 'white',
							},
						},

						MenuProps: {
							MenuListProps: { disablePadding: true },
						},
					}}
					className={styles.textFieldDropdown}
					MenuListProps={{ disablePadding: true }}
				>
					{projects.map((project) => (
						<MenuItem key={project.id} value={project?.id}>
							{project?.companyName}
						</MenuItem>
					))}
				</TextField>
			</FormControl>
		</div>
	);
};

const mapStateToProps = (state) => ({
	projects: state.userManagement.projects,
});

export default connect(mapStateToProps, { getClickedUser })(ProjectSelector);
